/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Passkey_Error_OptionsInputs */



/**
* | output |
* | --- |
* | "Couldn't start passkey setup." |
*
* @param {Passkey_Error_OptionsInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const passkey_error_options = /** @type {((inputs?: Passkey_Error_OptionsInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Passkey_Error_OptionsInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Impossible de démarrer la configuration de la Passkey.")
	if (locale === "es") return /** @type {LocalizedString} */ ("No se pudo iniciar la configuración del Passkey.")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Não foi possível iniciar a configuração da Passkey.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Impossibile avviare la configurazione della Passkey.")
	return /** @type {LocalizedString} */ ("Couldn't start passkey setup.")
});